<div class="dialog-content-wrapper" style="margin: -24px;">
    <mat-toolbar matDialogTitle class="mat-indigo-800-bg m-0 customBlue">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">{{translations.CPlblChangePassword}}</span>
            <button mat-button class="mat-icon-button" (click)="dialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>


    </mat-toolbar>
    <div mat-dialog-content class="p-24 m-0" fusePerfectScrollbar style="padding-bottom:0px !important;">
        <form [formGroup]="ChangePwdForm" novalidate>
            <div fxLayout="row" fxLayoutAlign="start right">
                <mat-form-field class="mr-24"  fxFlex.xs="100" fxFlex="100">
                    <input matInput placeholder="{{translations.CPtxtOldPassword}}" 
                    type="password" formControlName="LastPassword" [(ngModel)]="login.OldPassword"
                           [type]="hide ? 'password' : 'text'" maxlength="10" (ngModelChange)="checkPassword()">
                    <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                    <mat-error *ngIf="ChagePwdFormErrors.LastPassword.required">
                        {{translations.CPmsgOldPasswordRequired}}
                    </mat-error>
                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="start right">
                <mat-form-field class="mr-24"  fxFlex.xs="100" fxFlex="100">
                    <input matInput placeholder="{{translations.CPtxtNewPassword}}" 
                    type="password" formControlName="Password" [(ngModel)]="login.Password"
                           [type]="nHide ? 'password' : 'text'" maxlength="10" (ngModelChange)="checkPassword()">
                    <mat-hint align="end">{{login.Password?.length || 0}}/10</mat-hint>
                    <mat-icon matSuffix (click)="nHide = !nHide">{{nHide ? 'visibility_off' : 'visibility'}}</mat-icon>
                    <mat-error *ngIf="ChagePwdFormErrors.Password.required">
                        {{translations.CPmsgNewPasswordRequired}}
                    </mat-error>
                    <mat-hint *ngIf="diffOldPassword" style="color:red">{{translations.CPmsgOldAndNewSame}} </mat-hint>
                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="start right">
                <mat-form-field class="mr-24"  fxFlex.xs="100" fxFlex="100">
                    <input matInput placeholder="{{translations.CPtxtConfirmPassword}}" 
                    type="password" formControlName="ConfirmPassword" [(ngModel)]="login.ConfirmPassword"
                           [type]="cHide ? 'password' : 'text'" maxlength="10" (ngModelChange)="checkPassword()">
                    <mat-icon matSuffix (click)="cHide = !cHide">{{cHide ? 'visibility_off' : 'visibility'}}</mat-icon>
                    <mat-error *ngIf="ChagePwdFormErrors.ConfirmPassword.required">
                        {{translations.CPmsgConfirmPasswordRequired}}
                    </mat-error>
                    <mat-hint *ngIf="diffConfirmPassword" style="color:red">{{translations.CPmsgNewConfirmPassMismatch}} </mat-hint>
                </mat-form-field>
            </div>
        </form>

    </div>
    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="left">
        <button mat-raised-button color="accent" aria-label="SAVE" 
        [disabled]="invalidform" (click)="changePassword();" fxFlex="47" style="max-width: 100% !important;">
            {{translations.CPbtnSave}}
        </button>
    </div>
</div>


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/change-password/change-password.component.html